import { ListItem, StyledComponentProps, Divider } from '@material-ui/core';
import * as React from 'react';
import { medicalExamination } from '../../../../model/medicalexamination';

import { MexInfo } from './MexInfo';

interface IContactItemProps extends StyledComponentProps {
    medicalExamination: medicalExamination;
    onMedicalExaminationClick: (_id: string) => void;
    isSelected: boolean;
}

interface IContactItemState {
    // open: boolean;
    // openRoom: boolean;
}

export class MexItem extends React.Component<IContactItemProps, IContactItemState> {
    state = { open: false, openRoom: false }

    renderStyle = (_mex: medicalExamination) => {
        var x: React.CSSProperties = {};
        if (_mex.isValidateByGym) {
            x = { backgroundColor: '#1EB24C', color: 'white', fontWeight: 'bold' };
        }
        if (_mex.isDeleted) {
            x = { backgroundColor: '#d01515ff', color: 'white', fontWeight: 'bold' };
        }
        return x;
    }

    onButtonClick = (item: any) => {
        console.log("onButtonClick 2:", item)
        this.props.onMedicalExaminationClick(item)
    };

    onItemClick = (event: any, item: any) => {
        event.preventDefault();
        console.log("onItemClick:", item)
        navigator.clipboard.writeText(item)
    };

    render() {
        const { medicalExamination, classes } = this.props;
        return (
            <>
                <ListItem button
                    onClick={(e) => this.onItemClick(e, this.props.medicalExamination.sub)}
                    // className={this.props.isSelected ? classes.selectedBirthday : classes.birthday}
                    style={this.renderStyle(medicalExamination)}>
                    <MexInfo classes={classes}
                        medicalExamination={medicalExamination}
                        onClick={this.onButtonClick} />
                </ListItem>
                < Divider />
            </>
        );
    }
}